module.exports = __webpack_public_path__ + "static/media/teleMedDasboardBanner.a6ddb01c.svg";